import type { AnoMenuUrls } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import { DRACAENA_BASE_URL } from '@/lib/env'
import { useAuthStore } from '@/stores/auth'

interface UseAnoMenuItemsParams {
  ano: string | null
  pksId?: number | null
  salesforceProjectId?: number | null
}

/**
 * ANOバッジのドロップダウンに渡すURLを生成するフック
 * salesforceProjectId・pksId のいずれもない場合はundefinedを返し、ドロップダウン非表示とする
 * 各URLの有無はACL権限に応じて決まる
 */
export function useAnoMenuItems({ ano, pksId, salesforceProjectId }: UseAnoMenuItemsParams): AnoMenuUrls | undefined {
  const user = useAuthStore((state) => state.user)

  if (!salesforceProjectId && !pksId) {
    return undefined
  }

  const isAdministrator = !!user?.acl?.administrator
  const canViewAssign = !!user?.acl?.assign
  const canViewPks = !!user?.acl?.pks
  const canShowAssignLinks = salesforceProjectId && (isAdministrator || canViewAssign)
  const canShowPksLinks = isAdministrator || canViewPks

  return {
    monthlySales: canShowAssignLinks
      ? `${DRACAENA_BASE_URL}/salesforce/project/${salesforceProjectId}/monthly-sales/`
      : undefined,
    oldPks: pksId && canShowPksLinks ? `https://shiftinc-pks.intra.shiftinc.jp/projects/${pksId}` : undefined,
    projectBase:
      salesforceProjectId && canShowPksLinks
        ? `${DRACAENA_BASE_URL}/pks/salesforce/project/${salesforceProjectId}`
        : undefined,
    weeklyReports:
      ano && canShowPksLinks ? `${DRACAENA_BASE_URL}/pks/weekly/reports/results/all?search=${ano}` : undefined,
  }
}
